import React from "react";
import Selector from "canvas-core-react/lib/Selector";
import { useTranslation } from "react-i18next";

import config from "../../utils/config.json";

const ProviderIdType = ({ country, payMethod, error, name, ...rest }) => {
  const { t } = useTranslation();

  const providerCountry = ["CR", "PA"].includes(country) ? country : "INT";

  const payment =
    config[country]?.idTypes?.[payMethod] !== undefined ? payMethod : "default";

  const errorMessage = error
    ? {
        label: "Error",
        messages: [error],
      }
    : null;

  return (
    <>
      <Selector
        id={name}
        label="Tipo de identificación"
        name={name}
        placeholder={t("providers.manual.form.idType.placeholder")}
        error={errorMessage}
        {...rest}
      >
        {config[providerCountry]?.idTypes?.[payment]?.map((types, idx) => (
          <option key={`types-${idx}`} value={types.value}>
            {types.name}
          </option>
        )) || []}
      </Selector>
    </>
  );
};

export default ProviderIdType;
